import gql from "graphql-tag";

export const GENERATE_GENERIC_PRESIGNED_URL = gql`
  mutation generateGenereicPresignedUrl($path: String!) {
    generateGenericPresignedUrl(path: $path)
  }
`;
